// extracted by mini-css-extract-plugin
export default {"galleryThumbnail":"c-p_gl","galleryThumbnail_active":"c-p_gm","galleryThumbnail__image":"c-p_gn"};